export default function Hituji(){
    const name = "merry";

    return (
        <>
            <div>This is HITUJI</div>
            <p style={{color: "#339", fontSize: "2rem"}}>my name is {name}</p>
        </>
    )
}